module.exports = __webpack_public_path__ + "static/wichita-96855930f8fa193758822118cb1f5933.png";